<template>
  <div>
    <!-- Preloader -->
    <!-- <div class="preloader" id="preloader" v-if="isLoading" >
      <h3>sarvban.com</h3>
      <h6>{{sarvban_slogans[Math.floor(Math.random() * sarvban_slogans.length)]}}</h6>
      <div class="spinner-grow text-secondary" role="status">
        <div class="sr-only"></div>
      </div>
    </div> -->
    <div class="header-area" id="headerArea">
        <div class="container h-100 d-flex align-items-center justify-content-between d-flex ">
            
            <div class="sarv-navbar-toggler ms-2" data-bs-toggle="offcanvas" data-bs-target="#sarvOffcanvas"
                aria-controls="sarvOffcanvas">
                <div>
                    <span></span><span></span><span></span>
                </div>
            </div>
            <div v-show="!isHome" class="title-wrapper justify-start">
                <span class="col-10">{{ pageTitle }}</span>
            </div>
            <div v-show="isHome" class="header-logo brand-logo-enter">
                <img :src="`${baseURL}img/sarvban_logo_2.png`" alt="Sarvban" />
            </div>
            <div class="header-actions d-flex align-items-center gap-1">
              <NuxtLink :to="localePath('/')" class="topbar-btn home-btn" :title="$t('header.home')" aria-label="$t('header.home')">
                <i class="fa-solid fa-house"></i>
              </NuxtLink>
              <div class="support-btn-wrap" ref="supportWrapRef">
                <button class="support-btn topbar-btn" @click="toggleSupport" :title="$t('header.support')" :aria-expanded="isSupportOpen" aria-haspopup="true">
                  <i class="fa-solid fa-phone"></i>
                </button>
                <transition name="support-drop">
                  <div v-if="isSupportOpen" class="support-dropdown" role="menu">
                    <a :href="`https://wa.me/989332213064`" target="_blank" rel="noopener" class="support-option support-option-whatsapp" role="menuitem">
                      <i class="fa-brands fa-whatsapp"></i>
                      <span>{{ $t('header.support_whatsapp') }}</span>
                    </a>
                    <a href="tel:094222054321" class="support-option support-option-call" role="menuitem">
                      <i class="fa-solid fa-phone"></i>
                      <span>{{ $t('header.support_call') }}</span>
                    </a>
                    <a :href="`tel:02191309290`" class="support-option support-option-call" role="menuitem">
                      <i class="fa-solid fa-phone-volume"></i>
                      <span dir="ltr">021-91309290</span>
                    </a>
                  </div>
                </transition>
              </div>
              <button class="search-btn topbar-btn" @click="toggleSearch" :title="$t('home.search_placeholder')">
                <i :class="isSearchOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-magnifying-glass'"></i>
              </button>
              <div class="lang-dropdown">
                <button class="lang-btn topbar-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" :title="locale === 'fa' ? $t('common.lang_fa') : locale === 'en' ? $t('common.lang_en') : locale === 'ar' ? $t('common.lang_ar') : locale === 'ru' ? $t('common.lang_ru') : $t('common.lang_tr')">
                  <i class="fa-solid fa-globe"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end lang-menu" aria-labelledby="langSwitcher">
                  <li><a class="dropdown-item" href="#" @click.prevent="switchLanguage('fa')" :class="{active:locale==='fa'}"><i class="fa-solid fa-check me-2" v-if="locale==='fa'"></i> {{ $t('common.lang_fa') }}</a></li>
                  <li><a class="dropdown-item" href="#" @click.prevent="switchLanguage('en')" :class="{active:locale==='en'}"><i class="fa-solid fa-check me-2" v-if="locale==='en'"></i> {{ $t('common.lang_en') }}</a></li>
                  <li><a class="dropdown-item" href="#" @click.prevent="switchLanguage('ar')" :class="{active:locale==='ar'}"><i class="fa-solid fa-check me-2" v-if="locale==='ar'"></i> {{ $t('common.lang_ar') }}</a></li>
                  <li><a class="dropdown-item" href="#" @click.prevent="switchLanguage('ru')" :class="{active:locale==='ru'}"><i class="fa-solid fa-check me-2" v-if="locale==='ru'"></i> {{ $t('common.lang_ru') }}</a></li>
                  <li><a class="dropdown-item" href="#" @click.prevent="switchLanguage('tr')" :class="{active:locale==='tr'}"><i class="fa-solid fa-check me-2" v-if="locale==='tr'"></i> {{ $t('common.lang_tr') }}</a></li>
                </ul>
              </div>
              <div v-show="isProductPage" class="filter-option ms-2" data-bs-toggle="offcanvas" data-bs-target="#sarvFilterOffcanvas" aria-controls="sarvFilterOffcanvas"><i class="fa-solid fa-sliders"></i></div>
              <button class="topbar-btn" @click="goBack" :title="isMySarvban ? $t('header.home') : $t('header.back')">
                <i :class="isMySarvban ? 'fa-solid fa-home' : 'fa-solid fa-arrow-left'"></i>
              </button>
            </div>
        </div>

        <transition name="search-drop">
          <div v-if="isSearchOpen" class="header-search-bar" :class="{ 'search-busy': searchLoading }">
            <form class="header-search-form" @submit.prevent="submitSearch">
              <input
                ref="searchInput"
                class="header-search-input"
                type="search"
                v-model="searchQuery"
                :placeholder="$t('home.search_placeholder')"
                autocomplete="off"
                @focus="searchFocused = true"
                @blur="onSearchBlur"
                @keydown.esc="closeSearch"
              >
              <button type="submit" class="header-search-submit" :disabled="searchQuery.trim().length < 3 || searchLoading">
                <span v-if="searchLoading" class="search-loading">
                  <svg class="spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                  </svg>
                </span>
                <i v-else class="fa-solid fa-arrow-left"></i>
              </button>
            </form>

            <transition name="list-fade">
              <ul v-if="showSearchDropdown" class="header-search-dropdown">
                <li
                  v-for="(item, index) in searchResults"
                  :key="item.value || index"
                  class="header-search-item"
                  @mousedown.prevent="selectCategory(item)"
                >
                  <i class="fa-solid fa-tag me-2"></i>
                  <span class="header-search-item-label">{{ item.label }}</span>
                  <i class="fa-solid fa-angle-left ms-auto search-item-chev"></i>
                </li>
                <li v-if="searchResults.length === 0 && !searchLoading" class="header-search-item no-results">
                  <i class="fa-solid fa-circle-info me-2"></i>
                  {{ $t('common.no_results') }}
                </li>
                <li v-if="searchLoading" class="header-search-item no-results">
                  <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ $t('common.loading') }}
                </li>
              </ul>
            </transition>
          </div>
        </transition>
    </div>
    <div class="offcanvas offcanvas-start sarv-offcanvas-wrap" tabindex="-1" id="sarvOffcanvas" aria-labelledby="sarvOffcanvasLabel" aria-modal="true" role="dialog">
      <button class="oc-close" type="button" data-bs-dismiss="offcanvas" aria-label="Close">
        <i class="fa-solid fa-xmark"></i>
      </button>
      <div class="oc-grain"></div>
      <div class="offcanvas-body">
          <div class="oc-profile">
              <div class="oc-avatar-ring">
                  <div class="oc-avatar">
                      <img :src="`${baseURL}img/sv-192.png`" :alt="$t('headerNav.logo_alt')">
                  </div>
              </div>
              <div class="oc-user-info">
                  <h5 class="oc-brand">{{ $t('headerNav.system_name') }}</h5>
                  <p v-show="isLoggedIn" class="oc-username">{{ userName }}</p>
              </div>
          </div>

          <div class="oc-divider"></div>

          <nav class="oc-nav">
              <NuxtLink :to="localePath('/')" class="oc-nav-item">
                  <span class="oc-nav-icon"><i class="fa-solid fa-house"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.home') }}</span>
              </NuxtLink>
              <NuxtLink :to="localePath('/products')" class="oc-nav-item">
                  <span class="oc-nav-icon"><i class="fa-solid fa-search"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.products') }}</span>
              </NuxtLink>
              <NuxtLink :to="localePath('/my-sarvban')" class="oc-nav-item">
                  <span class="oc-nav-icon"><i class="fa-solid fa-user"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.my_sarvban') }}</span>
              </NuxtLink>
              <NuxtLink :to="localePath('/add-adv')" class="oc-nav-item">
                  <span class="oc-nav-icon"><i class="fa-solid fa-plus-circle lni-tada-effect"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.add_adv') }}</span>
              </NuxtLink>

              <div class="oc-dropdown" :class="{ 'is-open': isPriceBanOpen }">
                  <button class="oc-nav-item oc-dropdown-trigger" @click="isPriceBanOpen = !isPriceBanOpen">
                      <span class="oc-nav-icon"><i class="fa-solid fa-store"></i></span>
                      <span class="oc-nav-label">{{ $t('headerNav.price_ban') }}</span>
                      <span class="oc-chevron"><i class="fa-solid fa-chevron-down"></i></span>
                  </button>
                  <div class="oc-dropdown-menu">
                      <NuxtLink :to="localePath('/region/bar/tehran')" class="oc-dropdown-item">{{ $t('headerNav.price_tehran') }}</NuxtLink>
                      <NuxtLink :to="localePath('/region/bar/esfahan')" class="oc-dropdown-item">{{ $t('headerNav.price_esfahan') }}</NuxtLink>
                      <NuxtLink :to="localePath('/region/bar/shiraz')" class="oc-dropdown-item">{{ $t('headerNav.price_shiraz') }}</NuxtLink>
                      <NuxtLink :to="localePath('/region/bar/bandar')" class="oc-dropdown-item">{{ $t('headerNav.price_bandar') }}</NuxtLink>
                      <NuxtLink :to="localePath('/region/bar/mashhad')" class="oc-dropdown-item">{{ $t('headerNav.price_mashhad') }}</NuxtLink>
                      <NuxtLink :to="localePath('/region/bar/kerman')" class="oc-dropdown-item">{{ $t('headerNav.price_kerman') }}</NuxtLink>
                      <NuxtLink :to="localePath('/region/bar/fruit')" class="oc-dropdown-item">{{ $t('headerNav.price_urban_tehran') }}</NuxtLink>
                      <NuxtLink :to="localePath('/region/bar/dam')" class="oc-dropdown-item">{{ $t('headerNav.price_livestock_inputs') }}</NuxtLink>
                      <NuxtLink :to="localePath('/region/bar/mush')" class="oc-dropdown-item">{{ $t('headerNav.price_mushroom') }}</NuxtLink>
                  </div>
              </div>

              <NuxtLink :to="localePath('/amayesh')" class="oc-nav-item">
                  <span class="oc-nav-icon"><i class="fa-solid fa-file-code"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.product_ban') }}</span>
              </NuxtLink>
              <NuxtLink :to="localePath('/about-sarvban')" class="oc-nav-item">
                  <span class="oc-nav-icon"><i class="fa-solid fa-circle-info"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.sarvban_story') }}</span>
              </NuxtLink>
              <NuxtLink :to="localePath('/about-services')" class="oc-nav-item">
                  <span class="oc-nav-icon"><i class="fa-solid fa-heart"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.sarvban_services') }}</span>
              </NuxtLink>
              <NuxtLink :to="localePath('/contact')" class="oc-nav-item">
                  <span class="oc-nav-icon"><i class="fa-solid fa-phone"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.contact') }}</span>
              </NuxtLink>
          </nav>

          <div class="oc-divider"></div>

          <nav class="oc-nav oc-nav-secondary">
              <NuxtLink v-if="isLoggedIn" :to="localePath('/logout')" class="oc-nav-item oc-logout">
                  <span class="oc-nav-icon"><i class="fa-solid fa-right-from-bracket"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.logout') }}</span>
              </NuxtLink>
              <NuxtLink v-else :to="localePath('/login')" class="oc-nav-item oc-login">
                  <span class="oc-nav-icon"><i class="fa-solid fa-right-to-bracket"></i></span>
                  <span class="oc-nav-label">{{ $t('auth.login') }}</span>
              </NuxtLink>
              <NuxtLink :to="localePath('/agriment')" class="oc-nav-item">
                  <span class="oc-nav-icon"><i class="fa-solid fa-file-shield"></i></span>
                  <span class="oc-nav-label">{{ $t('headerNav.rules') }}</span>
              </NuxtLink>
          </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, onBeforeUnmount, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter, useLocalePath } from '#imports'
const { locale, setLocale, t } = useI18n()
const localePath = useLocalePath()
const router = useRouter()
const route = useRoute()
const baseURL = useRuntimeConfig().app.baseURL

const switchLanguage = async (lang) => {
  await setLocale(lang)
}

// State
const isLoading = ref(false)
const isMenuOpen = ref(false)
const isPriceBanOpen = ref(false)
const isProductPage = ref(false)

// Support dropdown state
const isSupportOpen = ref(false)
const supportWrapRef = ref(null)
const toggleSupport = () => {
  isSupportOpen.value = !isSupportOpen.value
}
const onDocumentClick = (e) => {
  if (supportWrapRef.value && !supportWrapRef.value.contains(e.target)) {
    isSupportOpen.value = false
  }
}

// Search state
const isSearchOpen = ref(false)
const searchQuery = ref('')
const searchResults = ref([])
const showSearchDropdown = ref(false)
const searchLoading = ref(false)
const searchFocused = ref(false)
const searchInput = ref(null)
let searchTimeout = null
let searchCloseTimeout = null

const { authenticated, user } = useAuth()
const isLoggedIn = computed(() => authenticated.value)
const userName = computed(() => user.value?.name || user.value?.mobile || '')
const isHome = computed(() => route.path === localePath('/') || route.path === localePath('/home'))

const pageTitle = computed(() => {
  if (route.path.startsWith('/details/') || route.path.startsWith('/prod/')) {
    return t('header.product_details')
  }
  return t('header.site_name')
})
const isMySarvban = computed(() => route.path.includes(localePath('/my-sarvban')))
const goBack = () => {
  if (isMySarvban.value) {
    router.push(localePath('/'))
  } else {
    router.back()
  }
}
// Methods
const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
  
  // Prevent body scroll when menu is open
  if (isMenuOpen.value) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
}

const toggleSearch = () => {
  isSearchOpen.value ? closeSearch() : openSearch()
}

const openSearch = () => {
  isSearchOpen.value = true
  nextTick(() => searchInput.value?.focus())
}

const closeSearch = () => {
  isSearchOpen.value = false
  searchQuery.value = ''
  searchResults.value = []
  showSearchDropdown.value = false
  searchFocused.value = false
}

const onSearchBlur = () => {
  searchCloseTimeout = setTimeout(() => {
    searchFocused.value = false
    showSearchDropdown.value = false
  }, 150)
}

const submitSearch = () => {
  const q = searchQuery.value.trim()
  if (q.length >= 3) {
    showSearchDropdown.value = false
    closeSearch()
    router.push(localePath(`/search/${encodeURIComponent(q)}`))
  }
}

const selectCategory = (item) => {
  showSearchDropdown.value = false
  closeSearch()
  router.push(localePath(`/cat/${item.value}/${encodeURIComponent(item.label)}`))
}

watch(searchQuery, (val) => {
  if (searchCloseTimeout) clearTimeout(searchCloseTimeout)
  if (searchTimeout) clearTimeout(searchTimeout)

  const q = val.trim()
  if (q.length < 3) {
    searchResults.value = []
    showSearchDropdown.value = false
    return
  }

  searchLoading.value = true
  searchTimeout = setTimeout(async () => {
    try {
      const res = await $fetch('/market/api/categories/search', {
        method: 'POST',
        body: { word: q }
      })
      const data = typeof res === 'string' ? JSON.parse(res) : res
      searchResults.value = Array.isArray(data) ? data : (data?.results || [])
      showSearchDropdown.value = searchFocused.value && searchResults.value.length > 0
    } catch (e) {
      console.error('Header search error:', e)
      searchResults.value = []
      showSearchDropdown.value = false
    } finally {
      searchLoading.value = false
    }
  }, 300)
})

onBeforeUnmount(() => {
  if (searchTimeout) clearTimeout(searchTimeout)
  if (searchCloseTimeout) clearTimeout(searchCloseTimeout)
  document.removeEventListener('click', onDocumentClick)
})

onMounted(() => {
  document.addEventListener('click', onDocumentClick)
  setTimeout(() => {
    isLoading.value = false
  }, 1000)
})
</script>

<style lang="scss" scoped>
@use "sass:color";
 .topbar-btn {
    width: 36px;
    height: 36px;
    border: none;
    background: $bg-light;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    color: $text-dark;
    font-size: 16px;
    flex-shrink: 0;
    text-decoration: none;
    
    &:hover {
      // background: darken($bg-light, 5%);
      background: color.adjust($bg-light, $lightness: -5%)
    }
    
    &:active {
      transform: scale(0.95);
    }
  }
  
  .home-btn {
    background: $leaf;
    color: #fff;
    
    &:hover {
      background: color.adjust($leaf, $lightness: -8%);
      color: #fff;
    }
  }

  .support-btn-wrap {
    position: relative;
    display: flex;
  }

  .support-btn {
    background: color.adjust($leaf, $lightness: -12%);
    color: #fff;

    &:hover {
      background: color.adjust($leaf, $lightness: -20%);
      color: #fff;
    }
  }

  .support-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    inset-inline-end: 0;
    width: 210px;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 14px;
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.14);
    padding: 8px;
    z-index: 1300;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .support-option {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 10px;
    text-decoration: none;
    font-size: 13.5px;
    font-weight: 600;
    color: $text-dark;
    transition: all 0.2s ease;
    cursor: pointer;

    i {
      width: 34px;
      height: 34px;
      border-radius: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #fff;
      flex-shrink: 0;
    }

    &:hover {
      background: #f4f6f5;
    }
  }

  .support-option-whatsapp i {
    background: #25d366;
  }

  .support-option-call i {
    background: $leaf;
  }

  .support-drop-enter-active, .support-drop-leave-active {
    transition: all 0.25s cubic-bezier(0.22, 1, 0.36, 1);
  }
  .support-drop-enter-from, .support-drop-leave-to {
    opacity: 0;
    transform: translateY(-8px) scale(0.96);
  }
  .lang-btn {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.5px;

    &::after {
      display: none;
    }
  }
  .lang-dropdown {
    position: relative;

    .lang-menu {
      min-width: 140px;
      border-radius: 12px;
      border: 1px solid $cream-dark;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      padding: 6px;
      font-size: 13px;

      .dropdown-item {
        border-radius: 8px;
        padding: 8px 12px;

        &:hover, &:focus {
          background: #e8f5e9;
          color: $leaf;
        }

        &.active {
          background: #e8f5e9;
          color: $leaf;
          font-weight: 600;
        }
      }
    }
  }
  .header-actions {
    gap: 4px;
  }

  .search-btn {
    background: $leaf;
    color: #fff;

    &:hover {
      background: color.adjust($leaf, $lightness: -8%);
      color: #fff;
    }
  }

  .header-search-bar {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    z-index: 1200;
    margin-top: 10px;

    .header-search-form {
      display: flex;
      align-items: center;
      background: #fff;
      border: 2px solid $leaf;
      border-radius: 12px;
      padding: 4px;
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
      min-height: 52px;

      .header-search-input {
        flex: 1;
        border: none;
        outline: none;
        background: transparent;
        padding: 8px 16px;
        font-size: 15px;
        color: $text-dark;
        &::placeholder {
          color: #9aa0a6;
        }
      }

      .header-search-submit {
        width: 44px;
        height: 44px;
        flex-shrink: 0;
        border: none;
        border-radius: 9px;
        background: $leaf;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s;
        position: relative;
        &:disabled {
          background: #cfd4da;
          cursor: not-allowed;
        }
        &:hover:not(:disabled) {
          background: color.adjust($leaf, $lightness: -10%);
        }
        .search-loading {
          display: flex;
          align-items: center;
          justify-content: center;
          .spinner {
            width: 20px;
            height: 20px;
            animation: spin 1s linear infinite;
          }
        }
      }

      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    }

    .header-search-dropdown {
      list-style: none;
      margin: 8px 0 0;
      padding: 6px;
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 12px;
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
      max-height: 320px;
      overflow-y: auto;
      z-index: 1200;

      .header-search-item {
        display: flex;
        align-items: center;
        padding: 11px 12px;
        cursor: pointer;
        border-radius: 8px;
        transition: all 0.15s;
        color: #333;
        i { font-size: 13px; color: $leaf; }
        .header-search-item-label {
          flex: 1;
          font-size: 14px;
          font-weight: 500;
        }
        .search-item-chev {
          font-size: 12px;
          color: #b6bdc4;
        }
        &:hover {
          background: #e8f5e9;
          color: $leaf;
          .header-search-item-label { color: $leaf; }
        }
        &.no-results {
          cursor: default;
          color: #9aa0a6;
          &:hover { background: transparent; }
        }
      }
    }
  }

  .search-drop-enter-active, .search-drop-leave-active {
    transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
  }
  .search-drop-enter-from, .search-drop-leave-to {
    opacity: 0;
    transform: translateY(-12px) scale(0.98);
  }

  .list-fade-enter-active, .list-fade-leave-active {
    transition: all 0.25s ease;
  }
  .list-fade-enter-from, .list-fade-leave-to {
    opacity: 0;
    transform: translateY(-6px);
  }

  .header-logo {
    flex-shrink: 0;
    overflow: hidden;

    img {
      height: 36px;
      width: auto;
      object-fit: contain;
      display: block;
    }
  }

  @keyframes brandLogoEnter {
    0% {
      opacity: 0;
      transform: translateX(20px) scale(0.8);
      filter: blur(4px);
    }
    60% {
      opacity: 1;
      transform: translateX(-4px) scale(1.05);
      filter: blur(0);
    }
    100% {
      opacity: 1;
      transform: translateX(0) scale(1);
      filter: blur(0);
    }
  }

  .brand-logo-enter {
    animation: brandLogoEnter 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s both;
  }
#preloader {
    background: var(--primary, #1a9350);
}

#preloader h3 {
  position: absolute;
  top: 48%;
  color: #ffffff;
  border-bottom: 1px solid #d0d0d0;
}

#preloader h6 {
    position: absolute;
    top: 55%;
    color: #ffffff;
    font-size: 0.9rem;

}
.spinner-grow {
  --bs-spinner-width: 50rem;
  --bs-spinner-height: 25rem;
}
.sarv-navbar-toggler {
  position: relative;
  z-index: 1;
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.sarv-navbar-toggler div {
  position: relative;
  z-index: 1;
}
.sarv-navbar-toggler span {
  -webkit-transition-duration: 500ms;
       -o-transition-duration: 500ms;
          transition-duration: 500ms;
  width: 16px;
  height: 2px;
  background-color: #747794;
  margin-bottom: 3px;
  display: block;
}
.sarv-navbar-toggler span:nth-child(2) {
  width: 8px;
}
.sarv-navbar-toggler span:last-child {
  margin-bottom: 0;
  width: 12px;
}
.sarv-navbar-toggler:hover span, .sarv-navbar-toggler:focus span {
  width: 16px;
}

.offcanvas,.offcanvas-lg,.offcanvas-md,.offcanvas-sm,.offcanvas-xl,.offcanvas-xxl {
    --bs-offcanvas-zindex: 1045;
    --bs-offcanvas-width: 400px;
    --bs-offcanvas-height: 30vh;
    --bs-offcanvas-padding-x: 1rem;
    --bs-offcanvas-padding-y: 1rem;
    --bs-offcanvas-color: ;
    --bs-offcanvas-bg: #fff;
    --bs-offcanvas-border-width: 1px;
    --bs-offcanvas-border-color: var(--bs-border-color-translucent);
    --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)
}

@media (max-width: 575.98px) {
    .offcanvas-sm {
        position:fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform .3s ease-in-out
    }
}

@media (max-width: 575.98px) and (prefers-reduced-motion:reduce) {
    .offcanvas-sm {
        transition:none
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-start {
        top:0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-end {
        top:0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-top {
        top:0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-bottom {
        right:0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.show:not(.hiding),.offcanvas-sm.showing {
        transform:none
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.hiding,.offcanvas-sm.show,.offcanvas-sm.showing {
        visibility:visible
    }
}

@media (min-width: 576px) {
    .offcanvas-sm {
        --bs-offcanvas-height:auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent!important
    }

    .offcanvas-sm .offcanvas-header {
        display: none
    }

    .offcanvas-sm .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent!important
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md {
        position:fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform .3s ease-in-out
    }
}

@media (max-width: 767.98px) and (prefers-reduced-motion:reduce) {
    .offcanvas-md {
        transition:none
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-start {
        top:0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-end {
        top:0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-top {
        top:0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-bottom {
        right:0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.show:not(.hiding),.offcanvas-md.showing {
        transform:none
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.hiding,.offcanvas-md.show,.offcanvas-md.showing {
        visibility:visible
    }
}

@media (min-width: 768px) {
    .offcanvas-md {
        --bs-offcanvas-height:auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent!important
    }

    .offcanvas-md .offcanvas-header {
        display: none
    }

    .offcanvas-md .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent!important
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg {
        position:fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform .3s ease-in-out
    }
}

@media (max-width: 991.98px) and (prefers-reduced-motion:reduce) {
    .offcanvas-lg {
        transition:none
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-start {
        top:0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-end {
        top:0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-top {
        top:0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-bottom {
        right:0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.show:not(.hiding),.offcanvas-lg.showing {
        transform:none
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.hiding,.offcanvas-lg.show,.offcanvas-lg.showing {
        visibility:visible
    }
}

@media (min-width: 992px) {
    .offcanvas-lg {
        --bs-offcanvas-height:auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent!important
    }

    .offcanvas-lg .offcanvas-header {
        display: none
    }

    .offcanvas-lg .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent!important
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl {
        position:fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform .3s ease-in-out
    }
}

@media (max-width: 1199.98px) and (prefers-reduced-motion:reduce) {
    .offcanvas-xl {
        transition:none
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-start {
        top:0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-end {
        top:0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-top {
        top:0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-bottom {
        right:0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.show:not(.hiding),.offcanvas-xl.showing {
        transform:none
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.hiding,.offcanvas-xl.show,.offcanvas-xl.showing {
        visibility:visible
    }
}

@media (min-width: 1200px) {
    .offcanvas-xl {
        --bs-offcanvas-height:auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent!important
    }

    .offcanvas-xl .offcanvas-header {
        display: none
    }

    .offcanvas-xl .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent!important
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl {
        position:fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform .3s ease-in-out
    }
}

@media (max-width: 1399.98px) and (prefers-reduced-motion:reduce) {
    .offcanvas-xxl {
        transition:none
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-start {
        top:0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%)
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-end {
        top:0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%)
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-top {
        top:0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%)
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-bottom {
        right:0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%)
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.show:not(.hiding),.offcanvas-xxl.showing {
        transform:none
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.hiding,.offcanvas-xxl.show,.offcanvas-xxl.showing {
        visibility:visible
    }
}

@media (min-width: 1400px) {
    .offcanvas-xxl {
        --bs-offcanvas-height:auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent!important
    }

    .offcanvas-xxl .offcanvas-header {
        display: none
    }

    .offcanvas-xxl .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent!important
    }
}

.offcanvas {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform .3s ease-in-out
}

@media (prefers-reduced-motion:reduce) {
    .offcanvas {
        transition: none
    }
}

.offcanvas.offcanvas-start {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%)
}

.offcanvas.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%)
}

.offcanvas.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%)
}

.offcanvas.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%)
}

.offcanvas.show:not(.hiding),.offcanvas.showing {
    transform: none
}

.offcanvas.hiding,.offcanvas.show,.offcanvas.showing {
    visibility: visible
}

.offcanvas-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000
}

.offcanvas-backdrop.fade {
    opacity: 0
}

.offcanvas-backdrop.show {
    opacity: .5
}

.offcanvas-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x)
}

.offcanvas-header .btn-close {
    padding: calc(var(--bs-offcanvas-padding-y) * .5) calc(var(--bs-offcanvas-padding-x) * .5);
    margin-top: calc(-.5 * var(--bs-offcanvas-padding-y));
    margin-right: calc(-.5 * var(--bs-offcanvas-padding-x));
    margin-bottom: calc(-.5 * var(--bs-offcanvas-padding-y))
}

.offcanvas-title {
    margin-bottom: 0;
    line-height: 1.5
}

.offcanvas-body {
    flex-grow: 1;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
    overflow-y: auto
}

.placeholder {
    display: inline-block;
    min-height: 1em;
    vertical-align: middle;
    cursor: wait;
    background-color: currentcolor;
    opacity: .5
}

.placeholder.btn::before {
    display: inline-block;
    content: ""
}

.placeholder-xs {
    min-height: .6em
}

.placeholder-sm {
    min-height: .8em
}

.placeholder-lg {
    min-height: 1.2em
}

.placeholder-glow .placeholder {
    animation: placeholder-glow 2s ease-in-out infinite
}

@keyframes placeholder-glow {
    50% {
        opacity: .2
    }
}

.placeholder-wave {
    -webkit-mask-image: linear-gradient(130deg,#000 55%,rgba(0,0,0,0.8) 75%,#000 95%);
    mask-image: linear-gradient(130deg,#000 55%,rgba(0,0,0,0.8) 75%,#000 95%);
    -webkit-mask-size: 200% 100%;
    mask-size: 200% 100%;
    animation: placeholder-wave 2s linear infinite
}

@keyframes placeholder-wave {
    100% {
        -webkit-mask-position: -200% 0%;
        mask-position: -200% 0%
    }
}

.clearfix::after {
    display: block;
    clear: both;
    content: ""
}

.offcanvas.offcanvas-start {
    right: 0;
}

/* ──────────────────────────────────────────────────────────
   OFFCANVAS — Dark Organic Green, matching homepage hero
────────────────────────────────────────────────────────── */
.sarv-offcanvas-wrap {
  width: 280px !important;
  border-right: 0 !important;
  background: linear-gradient(175deg, #0d2b1d 0%, #132f1e 35%, #0a2316 100%);
  overflow: hidden;
}

.sarv-offcanvas-wrap .offcanvas-body {
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.15) transparent;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.sarv-offcanvas-wrap .offcanvas-body::-webkit-scrollbar {
  width: 4px;
}
.sarv-offcanvas-wrap .offcanvas-body::-webkit-scrollbar-track {
  background: transparent;
}
.sarv-offcanvas-wrap .offcanvas-body::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.12);
  border-radius: 4px;
}

/* Close button */
.oc-close {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 100;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.06);
  color: rgba(255,255,255,0.7);
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  backdrop-filter: blur(8px);
}
.oc-close:hover {
  background: rgba(255,255,255,0.12);
  color: #fff;
  border-color: rgba(255,255,255,0.2);
}

/* Grain texture overlay */
.oc-grain {
  position: absolute;
  inset: 0;
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 30px,
    rgba(255,255,255,0.015) 30px,
    rgba(255,255,255,0.015) 31px
  );
  pointer-events: none;
  z-index: 0;
}

/* ── Profile Section ── */
.oc-profile {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 48px 20px 24px;
}

.oc-avatar-ring {
  width: 88px;
  height: 88px;
  margin: 0 auto 16px;
  border-radius: 50%;
  padding: 3px;
  background: linear-gradient(135deg, rgba(242,100,61,0.6), rgba(26,107,60,0.6), rgba(212,137,58,0.4));
}

.oc-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  background: #0d2b1d;
  display: flex;
  align-items: center;
  justify-content: center;
}
.oc-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.oc-brand {
  font-size: 1.05rem;
  font-weight: 700;
  color: #f4faf2;
  margin: 0 0 4px;
  letter-spacing: -0.2px;
}

.oc-username {
  font-size: 0.78rem;
  color: rgba(207,227,200,0.7);
  margin: 0;
  font-weight: 400;
}

/* ── Divider ── */
.oc-divider {
  height: 1px;
  margin: 0 20px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent);
  position: relative;
  z-index: 1;
}

/* ── Navigation ── */
.oc-nav {
  padding: 12px 12px;
  position: relative;
  z-index: 1;
}

.oc-nav-secondary {
  margin-top: auto;
  padding-bottom: 20px;
}

.oc-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  text-decoration: none;
  color: rgba(255,255,255,0.82);
  font-size: 0.88rem;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-bottom: 2px;
  position: relative;
}

.oc-nav-item:hover {
  background: rgba(255,255,255,0.07);
  color: #fff;
}

.oc-nav-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(255,255,255,0.06);
  font-size: 0.85rem;
  flex-shrink: 0;
  transition: all 0.25s ease;
}

.oc-nav-item:hover .oc-nav-icon {
  background: rgba(26,107,60,0.35);
}

.oc-nav-label {
  flex: 1;
  line-height: 1.4;
}

/* ── Dropdown ── */
.oc-dropdown {
  margin-bottom: 2px;
}

.oc-dropdown-trigger {
  width: 100%;
  background: none;
  border: none;
  font: inherit;
  cursor: pointer;
  text-align: inherit;
}

.oc-chevron {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255,255,255,0.06);
  font-size: 0.7rem;
  flex-shrink: 0;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.oc-dropdown.is-open .oc-chevron {
  transform: rotate(180deg);
  background: rgba(242,100,61,0.2);
  color: var(--saffron, #f2643d);
}

.oc-dropdown-menu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.3s ease,
              padding 0.3s ease;
  opacity: 0;
  padding: 0 0 0 46px;
}

.oc-dropdown.is-open .oc-dropdown-menu {
  max-height: 500px;
  opacity: 1;
  padding: 4px 0 4px 46px;
}

.oc-dropdown-item {
  display: block;
  padding: 10px 14px;
  color: rgba(207,227,200,0.65);
  text-decoration: none;
  font-size: 0.82rem;
  font-weight: 400;
  border-radius: 8px;
  transition: all 0.2s ease;
  position: relative;
}

.oc-dropdown-item::before {
  content: '';
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(207,227,200,0.25);
  transition: all 0.2s ease;
}

.oc-dropdown-item:hover {
  color: #f4faf2;
  background: rgba(255,255,255,0.05);
}
.oc-dropdown-item:hover::before {
  background: var(--saffron, #f2643d);
  box-shadow: 0 0 6px rgba(242,100,61,0.4);
}

/* ── Login / Logout ── */
.oc-login {
  background: linear-gradient(135deg, rgba(26,107,60,0.3), rgba(26,107,60,0.15));
  border: 1px solid rgba(26,107,60,0.25);
  color: #a8d5b8 !important;
}
.oc-login:hover {
  background: linear-gradient(135deg, rgba(26,107,60,0.45), rgba(26,107,60,0.25)) !important;
  border-color: rgba(26,107,60,0.4);
  color: #fff !important;
}
.oc-login .oc-nav-icon {
  background: rgba(26,107,60,0.3);
}

.oc-logout .oc-nav-icon {
  background: rgba(220,53,69,0.15);
}
.oc-logout:hover {
  background: rgba(220,53,69,0.1) !important;
  color: #f5a5aa !important;
}

.sarv-filter-offcanvas-wrap {
  width: 240px !important;
  border-right: 0;
  background-color: #ffffff;
}
.sarv-filter-offcanvas-wrap .btn-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 100;
}
.sarv-filter-offcanvas-wrap .offcanvas-body {
  scrollbar-width: thin;
}



.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

// Header Styles
.header-area {
  background: #f6f7f8;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  padding: 10px 0;
  
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .logo-box {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 6px 12px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;
    
    &:hover {
      background: #e9ecef;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
    
    a {
      display: block;
      text-decoration: none;
    }
    
    .logo-img {
      height: 40px;
      width: auto;
      object-fit: contain;
      display: block;
    }
  }
  
  .header-center {
    flex: 1;
    text-align: center;
    
    .header-title {
      margin: 0;
      font-size: 1.3rem;
      font-weight: 700;
      color: #03a054;
    }
  }
  
  .navbar-logo-container {
    .hamburger-btn {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 28px;
      height: 20px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
      
      span {
        display: block;
        width: 100%;
        height: 3px;
        background: #333;
        border-radius: 2px;
        transition: all 0.3s ease;
      }
      
      &:hover span {
        background: #03a054;
      }
    }
  }
}

// App Drawer Overlay
.app-drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  
  &.active {
    opacity: 1;
    visibility: visible;
  }
}

// App Drawer
.app-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  max-width: 85vw;
  height: 100%;
  background: #fff;
  z-index: 1002;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  box-shadow: -5px 0 20px rgba(0, 0, 0, 0.15);
  
  &.open {
    transform: translateX(0);
  }
}

// Drawer Header
.drawer-header {
  background: linear-gradient(135deg, #03a054 0%, #028a46 100%);
  padding: 30px 20px 20px;
  position: relative;
  
  .drawer-profile {
    display: flex;
    align-items: center;
    gap: 15px;
    
    .avatar {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      border: 3px solid rgba(255, 255, 255, 0.3);
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    
    .user-info {
      .user-name {
        color: #fff;
        font-size: 1.1rem;
        font-weight: 600;
        margin: 0 0 5px;
      }
      
      .user-email {
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.85rem;
        margin: 0;
      }
    }
  }
  
  .drawer-close {
    position: absolute;
    top: 15px;
    left: 15px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: #fff;
    font-size: 1.1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}

// Drawer Body
.drawer-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// Drawer Navigation
.drawer-nav {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
  
  .nav-item {
    display: flex;
    align-items: center;
    padding: 14px 20px;
    color: #333;
    text-decoration: none;
    transition: all 0.2s ease;
    border-bottom: 1px solid #f0f0f0;
    
    i {
      width: 24px;
      margin-left: 12px;
      color: #03a054;
      font-size: 1.1rem;
    }
    
    span {
      flex: 1;
      font-size: 0.95rem;
    }
    
    .badge {
      background: #ffc107;
      color: #333;
      font-size: 0.7rem;
      padding: 2px 8px;
      border-radius: 10px;
      font-weight: 600;
    }
    
    &:hover {
      background: #f8f9fa;
      color: #03a054;
    }
    
    &.active {
      background: #e8f5e9;
      color: #03a054;
    }
  }
  
  // Dropdown
  .nav-item.dropdown {
    padding: 0;
    border-bottom: none;
    
    .nav-link {
      display: flex;
      align-items: center;
      padding: 14px 20px;
      color: #333;
      text-decoration: none;
      cursor: pointer;
      transition: all 0.2s ease;
      border-bottom: 1px solid #f0f0f0;
      
      i {
        width: 24px;
        margin-left: 12px;
        color: #03a054;
        font-size: 1.1rem;
        
        &.arrow {
          width: auto;
          margin-left: 0;
          font-size: 0.75rem;
          color: #999;
          transition: transform 0.3s ease;
        }
      }
      
      span {
        flex: 1;
        font-size: 0.95rem;
      }
      
      &:hover {
        background: #f8f9fa;
      }
    }
    
    &.open {
      .nav-link .arrow {
        transform: rotate(180deg);
      }
    }
    
    .dropdown-menu {
      list-style: none;
      margin: 0;
      padding: 0;
      background: #f8f9fa;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease;
      
      li {
        a {
          display: block;
          padding: 12px 20px 12px 20px;
          padding-right: 56px;
          color: #666;
          text-decoration: none;
          font-size: 0.85rem;
          transition: all 0.2s ease;
          border-bottom: 1px solid #eee;
          
          &:hover {
            background: #e9ecef;
            color: #03a054;
          }
        }
      }
    }
    
    &.open .dropdown-menu {
      max-height: 300px;
    }
  }
}

// Drawer Footer
.drawer-footer {
  padding: 15px 20px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
  
  .btn-login,
  .btn-logout {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    text-decoration: none;
    font-size: 0.95rem;
    font-weight: 500;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
  }
  
  .btn-login {
    background: #03a054;
    color: #fff;
    
    &:hover {
      background: #028a46;
    }
  }
  
  .btn-logout {
    background: #dc3545;
    color: #fff;
    
    &:hover {
      background: #c82333;
    }
  }
}
</style>
